/* ======================================================================
   The Lentil Hub — Purchase options (one-time vs subscription)

   Bridges the purchase-option radios to the product form.

   The radios sit outside the form (where the Shopify Subscriptions app block used to
   render, so the layout is unchanged), while the hidden `selling_plan` input sits
   inside it. A native form POST only submits fields inside the form, so this keeps the
   two in step. The app block solved the same problem by intercepting submit; syncing a
   hidden field is less machinery and fails more visibly.

   Also mirrors the app block's price behaviour: the displayed price follows the selected
   option, using the figures Liquid rendered from Shopify's own selling plan allocations
   rather than recomputing a discount here.
   ====================================================================== */

(function () {
  'use strict';

  function init(root) {
    if (root.dataset.purchaseOptionsReady === 'true') return;

    const sectionEl = root.closest('.shopify-section') || document;
    const form      = sectionEl.querySelector('form[action*="/cart/add"]');
    if (!form) {
      console.warn('[purchase-options] no product form found — selling plan will not be submitted');
      return;
    }

    // The hidden field must live inside the form to be submitted. Create it if the
    // section template did not render one, so this works even if the two drift apart.
    let hidden = form.querySelector('input[name="selling_plan"]');
    if (!hidden) {
      hidden = document.createElement('input');
      hidden.type = 'hidden';
      hidden.name = 'selling_plan';
      hidden.className = 'selected-selling-plan-id';
      form.appendChild(hidden);
    }

    const radios = Array.from(root.querySelectorAll('input[type="radio"][data-radio-type]'));
    if (!radios.length) return;

    // Price nodes the theme already uses for the headline price, if present.
    const priceTargets = Array.from(
      sectionEl.querySelectorAll('[data-purchase-options-price]')
    );

    function sync() {
      const checked = radios.find(r => r.checked) || radios[0];
      const isPlan  = checked.dataset.radioType === 'selling_plan';

      // Empty string, not removal: Shopify treats an empty selling_plan as "one-time",
      // and leaving a stale id here would silently subscribe someone who chose one-time.
      hidden.value = isPlan ? (checked.dataset.sellingPlanId || '') : '';

      const price = checked.dataset.variantPrice;
      if (price) priceTargets.forEach(el => { el.textContent = price; });

      root.dataset.selectedPurchaseOption = isPlan ? 'subscription' : 'one_time';

      root.dispatchEvent(new CustomEvent('tlh:purchase-option-change', {
        bubbles: true,
        detail: { sellingPlanId: hidden.value || null, isSubscription: isPlan },
      }));
    }

    radios.forEach(r => r.addEventListener('change', sync));
    sync();

    root.dataset.purchaseOptionsReady = 'true';
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-purchase-options]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }

  // Re-init after a section re-render in the theme editor, and after any variant change
  // that replaces the markup.
  document.addEventListener('shopify:section:load', e => initAll(e.target));
  document.addEventListener('variant:change', () => initAll());
})();
